import { ApiError } from '../../../shared/shared.api';

/** The server lets another code go a minute after the last one. */
export const RESEND_INTERVAL_SECONDS = 60;

/** 42 → "0:42", 75 → "1:15". */
export function formatCountdown(seconds: number): string {
  const whole = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
}

/** How long a throttled send (429) says to wait, when it says. */
export function retryAfterSeconds(err: unknown): number | undefined {
  if (!(err instanceof ApiError) || err.status !== 429 || typeof err.body !== 'object' || err.body === null) return undefined;
  const value = (err.body as { retryAfterSeconds?: unknown }).retryAfterSeconds;
  return typeof value === 'number' && value > 0 ? value : undefined;
}
